import { gql } from 'shared/types/layoutcreator'

export const SWITCH_COVER_TEMPLATE = gql(/* GraphQL */ `
  mutation switchCoverTemplate(
    $groupId: String!
    $projectId: String!
    $templatePath: String!
    $side: String!
  ) {
    switchCoverTemplate(
      groupId: $groupId
      projectId: $projectId
      templatePath: $templatePath
      side: $side
    )
  }
`)

export const UPLOAD_CUSTOM_COVER = gql(/* GraphQL */ `
  mutation uploadCustomCover(
    $projectId: String!
    $side: String!
    $file: Upload!
  ) {
    uploadCustomCover(projectId: $projectId, side: $side, file: $file)
  }
`)

export const REMOVE_CUSTOM_COVER = gql(/* GraphQL */ `
  mutation removeCustomCover(
    $projectId: String!
    $side: String!
  ) {
    removeCustomCover(projectId: $projectId, side: $side)
  }
`)
